import { DataGrid } from '@material-ui/data-grid';
import { find, forEach } from 'lodash';
import React, { useEffect, useState, useContext, useMemo } from 'react';
import AppContext from '../../../App/AppContext';
import { PrimaryButton } from '../../../Core/FormInput';
import { assignedTechAndList, assignedTechnicianToJob, getAssignJobList } from '../../../Core/Service/workflowData-service';
import { Checkbox } from '@material-ui/core';
import './assign-technician.scss';
import { AppStorage } from '../../../Core/Service/storage-service';

const AssignTech = (props) => {
    const urlParams = new URLSearchParams(props.location.search.toLowerCase());
    const navigateToDashboard = urlParams.get('navigate') === 'true';
    const fromStep = urlParams.get('fromstep') === 'true';
    const { hideTopNavAndMenu, showToast } = useContext(AppContext);
    const [dropDown, setDropDown] = useState([]);

    const getClass = (params) => {
        if (params.row.isAssigned) {
            return 'is-assigned';
        } else if (params.row.selectedNext) {
            return 'will-be-assigned';
        }
    };
    const defaultColumns = [
        { field: 'name', headerName: 'Name', width: 225 },
        { field: 'jobAssigned', headerName: 'Jobs Assigned ', flex: 1.5 },
        {
            field: 'isAssigned',
            headerName: 'Assign',
            width: 105
        }
    ].map((c) => ({ ...c, cellClassName: getClass }));

    let isAssignTechnicianAllowed = AppStorage.getCanAssignTechnicianAllowed();
    let portalSettings = AppStorage.getPortalSetting();

    const [state, setState] = useState({
        jobId: props.match.params.jobId,
        technicians: [],
        isEnable: false
    });

    useEffect(() => {
        let fetchList = async () => {
            let JobDropdownList = await getAssignJobList();
            if (JobDropdownList.success) {
                setDropDown(JobDropdownList.data.list);
            }
        };
        fetchList();
    }, []);

    const onCheckboxClick = (id) => (e) => {
        const { checked } = e.target;
        if (isAssignTechnicianAllowed) {
            setState((st) => {
                let newSt = { ...st };
                const rw = find(newSt.technicians, (t) => t.id === id);
                if (rw) {
                    rw.selectedNext = checked; //!rw.selectedNext;
                    rw.isAssigned = checked; // !rw.isAssigned;
                    rw.mode = checked ? 'A' : 'D';
                }
                newSt.technicians = [...newSt.technicians];
                newSt.isEnable = true;
                return newSt;
            });
        }
    };
    const columns = () => {
        let allCols = [...defaultColumns];
        let col = allCols.find((c) => c.field === 'isAssigned');
        col.renderCell = (params) => (
            <>
                <Checkbox onClick={onCheckboxClick(params.row.id)} defaultChecked={params.value} disabled={!isAssignTechnicianAllowed} />
                {/* <input type="checkbox"  defaultChecked={params.value} onChange={onCheckboxClick(params.row.id)} /> */}
            </>
        );

        const onSelect = (id, event) => {
            const { value } = event.target;
            if (isAssignTechnicianAllowed) {
                setState((st) => {
                    let newSt = { ...st };
                    const rw = find(newSt.technicians, (t) => t.id === id);
                    if (rw) {
                        rw.inspectionSheetTypeID = value;
                        rw.mode = 'A';
                    }
                    newSt.technicians = [...newSt.technicians];
                    newSt.isEnable = true;
                    return newSt;
                });
            }
        };

        const onAxleChange = (id, event) => {
            const { value } = event.target;
            if (isAssignTechnicianAllowed) {
                setState((st) => {
                    let newSt = { ...st };
                    const rw = find(newSt.technicians, (t) => t.id === id);
                    if (rw) {
                        rw.noOfAxle = value;
                        rw.mode = 'A';
                    }
                    newSt.technicians = [...newSt.technicians];
                    newSt.isEnable = true;
                    return newSt;
                });
            }
        };

        if (portalSettings.portalSettingVehicleInspectionEnabled) {
            allCols.push({
                field: 'insp',
                headerName: 'Events',
                width: 200,
                sortable: false,
                renderCell: (params) => (
                    <div style={{ width: '100%', padding: '5px 0px' }}>
                        <select
                            style={{ width: '100%', height: 20, border: '1px solid #ccc' }}
                            disabled={!isAssignTechnicianAllowed}
                            onChange={(e) => onSelect(params.row.id, e)}
                        >
                            <option value="">None</option>
                            {dropDown.map((d) => (
                                <option key={d.id} value={d.id} selected={d.id === params.row.jobId}>
                                    {d.name}
                                </option>
                            ))}
                        </select>
                        {/* <SelectBox List={dropDown} fullWidth style={{ background: 'white' }} /> */}
                        {/* <input type="checkbox"  defaultChecked={params.value} onChange={onCheckboxClick(params.row.id)} /> */}
                    </div>
                )
            });
            allCols.push({
                field: 'noOfAxle',
                headerName: 'No. of axle',
                flex: 1.5,
                sortable: false,
                renderCell: (params) => (
                    <div style={{ width: '100%', padding: '5px 0px' }}>
                        <input
                            type="number"
                            style={{ width: '100%', height: 20, border: '1px solid #ccc' }}
                            disabled={!isAssignTechnicianAllowed}
                            onChange={(e) => onAxleChange(params.row.id, e)}
                        />
                    </div>
                )
            });
        }
        // let inspCol = allCols.find((c) => c.field === 'insp');
        // inspCol.renderCell = (params) => (
        //     <div style={{ width: '100%', padding: '5px 0px' }}>
        //         <select
        //             style={{ width: '100%', height: 20, border: '1px solid #ccc' }}
        //             disabled={!isAssignTechnicianAllowed}
        //             onChange={(e) => onSelect(params.row.id, e)}
        //         >
        //             <option value="">None</option>
        //             {dropDown.map((d) => (
        //                 <option key={d.id} value={d.id} selected={d.id === params.row.jobId}>
        //                     {d.name}
        //                 </option>
        //             ))}
        //         </select>
        //         {/* <SelectBox List={dropDown} fullWidth style={{ background: 'white' }} /> */}
        //         {/* <input type="checkbox"  defaultChecked={params.value} onChange={onCheckboxClick(params.row.id)} /> */}
        //     </div>
        // );
        // let NoOfAxleField = allCols.find((c) => c.field === 'noOfAxle');
        // NoOfAxleField.renderCell = (params) => (
        //     <div style={{ width: '100%', padding: '5px 0px' }}>
        //         <input
        //             type="number"
        //             style={{ width: '100%', height: 20, border: '1px solid #ccc' }}
        //             disabled={!isAssignTechnicianAllowed}
        //             onChange={(e) => onAxleChange(params.row.id, e)}
        //         />
        //     </div>
        // );
        return allCols;
    };

    const getAssignedTechAndOthers = async () => {
        const res = await assignedTechAndList(state.jobId);
        if (res.success) {
            setState((st) => ({ ...st, technicians: res.data }));
        } else {
            showToast(res.message);
        }
    };

    useEffect(() => {
        fromStep && hideTopNavAndMenu();
        getAssignedTechAndOthers();
    }, []);

    const saveTechnicianAndMove = async () => {
        const techToSave = state.technicians.filter((c) => c.mode);
        const res = await assignedTechnicianToJob(state.jobId, techToSave);
        if (res.success) {
            showToast(res.message);
            if (res.success && fromStep) {
                setTimeout(() => {
                    window.top.postMessage({ type: navigateToDashboard ? 'navigate-dashboard' : 'close-modal' }, '*');
                }, 1000);
            }
        }
        if (!res.success) {
            console.error(res);
        }
    };

    return (
        <>
            <div className="assign-tech-grid-container">
                <DataGrid
                    rows={state.technicians}
                    headerHeight={30}
                    rowHeight={30}
                    hideFooter={true}
                    columns={columns()}
                    pageSize={100}
                    disableColumnMenu={true}
                    showColumnRightBorder={true}
                />
                <PrimaryButton fullWidth className="mt-20" onClick={saveTechnicianAndMove} disabled={!state.isEnable}>
                    Assign/Unassign Technician
                </PrimaryButton>
            </div>
        </>
    );
};

export default AssignTech;
